import { Redirect } from "react-router-dom";
import { useSession } from "../context/session";

function PrivatePage({ children }) {
  const [session] = useSession();
  return session.authenticated ? children : <Redirect to="/login" />;
}

export { PrivatePage };
